import React, { FC, useEffect, useState } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { Layout as AntLayout, Menu, Button } from "antd";
import {
  DoubleRightOutlined,
  DoubleLeftOutlined,
  DashboardOutlined,
  FileOutlined,
  FundViewOutlined,
  FieldTimeOutlined,
  BugOutlined,
  FieldNumberOutlined,
  SnippetsOutlined,
  IssuesCloseOutlined,
  DeleteRowOutlined,
} from "@ant-design/icons";

import Head from "./head/Head";
import Header from "./header/Header";
import Footer from "./footer/Foooter";
import AppRoot from "./global/AppRoot";
import AppWrap from "./global/AppWrap";
// import FileManagerProvider from "../pages/app/file-manager/components/Context";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { updateSideNavCollapseStatus } from "../store/slices/projectManagement/SideNavCollapseStatus";

const { Sider, Content } = AntLayout;

// Home (Overall Dashboard)
// 	Projects { Active Projects,Closed Projects, Archived Projects, Recycle Bin }
// 	Checklist
// 	Overview (DropDown)

// Example menu structure based on permissions
const menuConfig = [
  {
    key: "home",
    label: "Home",
    icon: <DashboardOutlined />,
    path: "/pms/active-projects",
    permission: "view_home",
  },
  {
    key: "projects",
    label: "Projects",
    icon: <FundViewOutlined />,
    permission: "view_projects",
    children: [
      {
        key: "draft_projects",
        label: "Draft Projects",
        path: "/pms/draftProjects",
        icon: <FieldTimeOutlined />,
        permission: "draft_projects",
      },
      {
        key: "active_projects",
        label: "Active Projects",
        path: "/pms/active-projects",
        icon: <IssuesCloseOutlined />,
        permission: "active_projects",
      },
      {
        key: "inactive_projects",
        label: "Inactive Projects",
        path: "/pms/inactive-projects",
        icon: <IssuesCloseOutlined />,
        permission: "inactive_projects",
      },
      {
        key: "closed_projects",
        label: "Closed Projects",
        path: "/pms/closed-projects",
        icon: <DeleteRowOutlined />,
        permission: "closed_projects",
      },
      {
        key: "archived_projects",
        label: "Archived Projects",
        path: "/pms/archived-projects",
        icon: <FieldNumberOutlined />,
        permission: "archived_projects",
      },
      {
        key: "recycle_bin",
        label: "Recycle Bin",
        path: "/pms/recycle-bin",
        icon: <SnippetsOutlined />,
        permission: "recycle_bin",
      },
    ],
  },

  {
    key: "checklist_lists",
    label: "Checklist",
    path: "/pms/Checklist/checklist-lists",
    icon: <FileOutlined />,
    permission: "checklist_lists",
  },
  // {
  //   key: "overview",
  //   label: "OverView",
  //   icon: <FundViewOutlined />,
  //   permission: "view_overview",
  //   children: [
  //     {
  //       key: "timeSheets",
  //       label: "Time Sheets",
  //       path: "/pms/time-sheets",
  //       icon: <FieldTimeOutlined />,
  //       permission: "time_sheets",
  //     },
  //     {
  //       key: "issues",
  //       label: "Issues",
  //       path: "/pms/issues",
  //       icon: <BugOutlined />,
  //       permission: "manage_issues",
  //     },
  //     {
  //       key: "phases",
  //       label: "Phases",
  //       path: "/pms/phases",
  //       icon: <FieldNumberOutlined />,
  //       permission: "manage_phases",
  //     },
  //     {
  //       key: "tasks",
  //       label: "Tasks",
  //       path: "/pms/tasks",
  //       icon: <SnippetsOutlined />,
  //       permission: "manage_tasks",
  //     },
  //     {
  //       key: "users",
  //       label: "User Management",
  //       path: "/pms/calendar-creation",
  //       permission: "manage_users",
  //     },
  //   ],
  // },
];

// Example permissions list
const userPermissions = [
  "view_home",
  // "view_projects",
  "draft_projects",
  "active_projects",
  "inactive_projects",
  "closed_projects",
  "archived_projects",
  "recycle_bin",
  "view_checklist",
  "checklist_lists",
  "questions_preview",
  "time_sheets",
  "manage_users",
  "manage_issues",
  "manage_phases",
  "manage_tasks",
];

interface LayoutProps {
  title?: string;
}

const Layout: FC<LayoutProps> = ({ title }) => {
  // const [collapsed, setCollapsed] = useState(false);
  const dispatch = useDispatch();
  const { data: collapsed } = useSelector(
    (state: any) => state.SideNavCollapseStatus
  );

  const toggleCollapse = (value: boolean) => {
    console.log("collapsed", collapsed);
    dispatch(updateSideNavCollapseStatus(value));
  };

  // useEffect(() => {
  //   setCollapsed(collapsedStatus);
  // }, [collapsedStatus]);

  const navigate = useNavigate();
  const location = useLocation();

  const renderMenu = (items: any[]) =>
    items
      .filter((item) =>
        item.children
          ? item.children.some((child: any) =>
              userPermissions.includes(child.permission)
            )
          : userPermissions.includes(item.permission)
      )
      .map((item) => {
        if (item.children) {
          return {
            key: item.key,
            icon: item.icon,
            label: item.label,
            children: item.children
              .filter((child: any) =>
                userPermissions.includes(child.permission)
              )
              .map((child: any) => ({
                key: child.path,
                label: child.label,
                icon: child.icon || <></>,
              })),
          };
        }
        return {
          key: item.path,
          icon: item.icon,
          label: item.label,
        };
      });

  const onMenuClick = ({ key }: { key: string }) => {
    navigate(key);
  };
  const siderWidth = collapsed ? 64 : 250;
  return (
    <>
      <Head title={title || "Loading"} />
      <AntLayout style={{ overflow: "hidden" }}>
        {/* Fixed Sider */}
        <Sider
          width={250}
          collapsedWidth={64}
          collapsible
          collapsed={collapsed}
          // onCollapse={()=>setCollapsed(false)}
          trigger={
            <>
              <div
                style={{
                  borderTop: "1px solid #e5e9f2",
                  width: "90%",
                  margin: "0 auto 8px auto",
                }}
              />
              <div className="d-flex justify-content-center">
                <Button
                  type="text"
                  icon={
                    collapsed ? <DoubleRightOutlined /> : <DoubleLeftOutlined />
                  }
                  onClick={() => {
                    toggleCollapse(!collapsed);
                  }}
                  style={{
                    fontSize: "18px",
                    backgroundColor: "white",
                    color: "black",
                  }}
                />
              </div>
            </>
          }
          style={{
            marginTop: 48,
            overflow: "auto",
            height: "100vh",
            position: "fixed",
            left: 0,
            top: 0,
            bottom: 0,
            background: "#fff",
            borderRight: "1px solid #e5e9f2",
            zIndex: 1000,
          }}
        >
          {/* <div
            className="m-0 mb-1"
            style={{
              height: 47,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "0 10px",
            }}
          >
            <img
              src="https://procurexuatstg.blob.core.windows.net/procurexuatblob/orgs/org%20logo/orgLogo__038c1cf2-2a90-4901-80d1-16426c2546a5.png"
              // src="https://procurexuatstg.blob.core.windows.net/procurexuatblob/orgs/org%20logo/orgLogo__296d0d27-b2fd-4cd4-adf3-570b17c312b7.png"
              alt="Logo"
              style={{
                height: collapsed ? 20 : 25,
                marginRight: collapsed ? 0 : 8,
                transition: "all 0.3s",
              }}
            />
            {!collapsed && (
              <span
                style={{
                  fontWeight: "600",
                  fontSize: 16,
                  whiteSpace: "nowrap",
                  color: "black",
                }}
              >
                ProcureX
              </span>
            )}
          </div> */}

          <Menu
            theme="light"
            mode="inline"
            style={{
              // background: "#3b3a39",
              background: "#fff",
              // color:"#000",
            }}
            className="pt-1"
            selectedKeys={[location.pathname]}
            items={renderMenu(menuConfig)}
            onClick={onMenuClick}
          />
        </Sider>

        {/* Main Content Area */}
        <AntLayout
          style={{ marginLeft: siderWidth, transition: "margin-left 0.1s" }}
        >
          <AppRoot>
            <AppWrap>
              <div className="flex items-center justify-between px-4 bg-white shadow h-16 ">
                {/* <Button
                  type="text"
                  icon={
                    collapsed ? <DoubleRightOutlined /> : <DoubleLeftOutlined />
                  }
                  onClick={() => setCollapsed(!collapsed)}
                  style={{
                    fontSize: "18px",
                  }}
                /> */}
                <Header fixed />
              </div>
              <Content className="mt-4">
                <Outlet />
              </Content>
              <Footer />
            </AppWrap>
          </AppRoot>
        </AntLayout>
      </AntLayout>
    </>
  );
};

export default Layout;
